import { useTranslation } from 'react-i18next';

export default function ProjetsRecents() {
  const { t } = useTranslation('pintendre');

  const projets = [
    {
      title: t('projet_1_title'),
      desc: t('projet_1_desc'),
      img: "https://readdy.ai/api/search-image?query=Rural Quebec property with house and detached metal roof garage on large lot, standing seam metal roofing, open countryside setting, green fields, bright summer day, authentic rural residential photography, earthy tones with slate blue sky and copper roof details"
      ,
      alt: "toiture maison et garage Pintendre rang Saint-David",
    },
    {
      title: t('projet_2_title'),
      desc: t('projet_2_desc'),
      img: "https://readdy.ai/api/search-image?query=Converted old barn or agricultural building in Quebec countryside with restored metal roofing, rustic rural character, large property setting, warm afternoon light, authentic farm conversion photography, earthy tones with slate blue and copper accents"
      ,
      alt: "restauration grange convertie Pintendre Pointe-Lévy",
    },
    {
      title: t('projet_3_title'),
      desc: t('projet_3_desc'),
      img: "https://readdy.ai/api/search-image?query=Large single-family house in rural Quebec with new architectural asphalt shingle roof, spacious lot with trees, detached structures visible, country road nearby, bright daylight, warm earth tones with slate blue sky and copper chimney accents, authentic real estate photography"
      ,
      alt: "toiture bardeau architectural grande maison Pintendre",
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-8 md:mb-10 text-center">
          {t('projets_h2')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {projets.map((p, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg border border-gray-100 overflow-hidden hover:border-[#C77D3F]/30 transition-colors"
            >
              <div className="h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.alt}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="400"
                  height="300"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-[#1B2A4E] mb-1">{p.title}</h3>
                <p className="text-sm text-[#4A5568] leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}